/* eslint camelcase: 0 */
import { FileProperty } from '@/infrastructure/network/Monitaro/schema/models'
import { IFileProps, EmptyFilePropsFactory } from '@/entities/File'

export const toFileProps = (props: FileProperty | null | undefined): IFileProps => {
  if (!props) {
    return EmptyFilePropsFactory()
  }

  const { path, filename, thumbnail, extension, origin, width, height, size, mimetype } = props

  return EmptyFilePropsFactory({
    path,
    filename,
    thumbnail,
    extension,
    origin,
    width,
    height,
    size,
    mimetype
  })
}
